import React, { FC, useState, useRef, useEffect } from "react";
import { Setting } from "../App";
import classes from "../asset/css/main.module.css";
import { ShippingAddressViewType } from "../types/view/shipping-address-view-type";
import { Address } from "../components/shipping-address/Address";
import { useShippingAddress } from "../hooks/use-shipping-address";

export const ShippingAddress: FC<{ setting: Setting }> = ({ setting }) => {
  const [subscriptionContractId, setSubscriptionContractId] = useState("");
  const [shippingAddress, setShippingAddress] =
    useState<ShippingAddressViewType>();

  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setting.resize(root.current?.clientHeight ?? 0);
  }, [setting, root.current?.clientHeight, shippingAddress]);

  useShippingAddress(setting, setSubscriptionContractId, setShippingAddress);

  return (
    <>
      <div className={classes.mypage_subsc_container} ref={root}>
        <Address shippingAddress={shippingAddress} />
      </div>
    </>
  );
};
